import React from "react";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AssetDetailsSkeleton from "./AssetDetailsSkeleton";

import { CaptureProvider } from "../../../contexts/capture";
import { fetchAssetValues } from "../../../utils/asset";
import FormFields from "../../../views/capture/FormFields";
import useAuth from "../../../hooks/useAuth";
import { useProject } from "../../../contexts/project";
import { fullWidthDialog } from "../../../constants/dialog";

export default function AssetDetailsModal({
  asset,
  loading = false,
  onClose,
  narrow = false,
  footerActions = null,
}) {
  const { user } = useAuth();
  const currentProject = useProject();
  const display = currentProject?.fieldSettings;
  const { settings } = user.company;
  const warehouseDropdownEnabled = settings.warehouse_id_dropdown_menu;

  return (
    <Dialog
      open
      fullWidth
      maxWidth={narrow ? "xs" : false}
      onClose={onClose}
      disableEscapeKeyDown={false}
      BackdropProps={{
        onClick: onClose,
      }}
      sx={
        narrow
          ? fullWidthDialog
          : {
              "& .MuiDialog-paper": {
                maxWidth: "1100px",
                width: "100%",
              },
            }
      }
    >
      <DialogTitle sx={{ background: "#f4f6f8", display: "flex", justifyContent: "space-between" }}>
        <Box width="48px" />
        <Typography fontSize={24} fontWeight={500} color="textPrimary">
          Item Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ background: "#f4f6f8" }}>
        {loading ? (
          <AssetDetailsSkeleton narrow={narrow} />
        ) : (
          <Box>
            <CaptureProvider>
              <Formik key={asset?.id} initialValues={fetchAssetValues(asset)}>
                <FormFields
                  disabledForm
                  type="orders"
                  asset={asset}
                  loading={false}
                  displayClient={!warehouseDropdownEnabled}
                  displayProject={true}
                  displayWarehouse={warehouseDropdownEnabled}
                  overrideDisplayFields={display}
                  fullWidth={narrow}
                />
              </Formik>
            </CaptureProvider>
          </Box>
        )}
      </DialogContent>
      {footerActions && (
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: "flex-end" }}>
          {footerActions}
        </DialogActions>
      )}
    </Dialog>
  );
}
